export const PROBER_EVENT_DEFAULT = 'default'
export const PROBER_EVENT_ACTION = 'action'
export const PROBER_EVENT_ERROR = 'error'
export const PROBER_EVENT_CUSTOM = 'custom'
export const PROBER_EVENT_NAVIGATION = 'navigation'
export const PROBER_EVENT_NETWORK = 'network'
export const PROBER_EVENT_PAGEVIEW = 'pageview'
export const PROBER_EVENT_TIMING = 'timing'
export const PROBER_EVENT_REQUEST = 'request'
export const PROBER_EVENT_CLICK = 'click'
export const PROBER_EVENT_SLOWDOWN = 'slowdown'
export const PROBER_EVENT_FOCUS = 'focus'
